"use client"

import { Suspense, useEffect, useRef } from "react"
import { usePathname, useSearchParams } from "next/navigation"
// The facade queues until posthog-js loads at idle — see lib/posthog-client.ts
// for why it lives there and not in this file. No posthog-js/react: the
// context provider would put the library back on the shell's critical path.
import { posthog } from "@/lib/posthog-client"
import { SlowInteractionObserver } from "@/components/layout/page-performance"

function PostHogPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (pathname) {
      let url = window.origin + pathname
      const search = searchParams.toString()
      if (search) url += "?" + search
      posthog.capture("$pageview", { $current_url: url })
    }
  }, [pathname, searchParams])

  return null
}

export function PostHogIdentify({ email, name }: { email?: string | null; name?: string | null }) {
  const identified = useRef(false)

  useEffect(() => {
    if (email && !identified.current) {
      posthog.identify(email, {
        email,
        name: name || undefined,
      })
      identified.current = true
    }
  }, [email, name])

  return null
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    return <>{children}</>
  }

  return (
    <>
      <Suspense fallback={null}>
        <PostHogPageView />
        <SlowInteractionObserver />
      </Suspense>
      {children}
    </>
  )
}
